<template>
  <div class="jewellery">

    <!--導航-->
    <div class="navHead clearFix" style="height: 40px;">
      <div class="area">
        <img class="positionIcon" :src="require('@/assets/homeImg/home_icon_dibiao@2x.png')" alt="">
        <el-select class="chooseArea" value="810000">
          <el-option :label="$t('mall_home.location')" value="810000"></el-option>
        </el-select>
        <!--<img class="downArrow" :src="require('@/assets/homeImg/下  拉.png')" alt="">-->
      </div>
      <div class="rightHead displayR" style="justify-content: center;align-items: center;height: 40px;">
        <div class="account">
          <div style="display: flex;">
            <img :src="require('@/assets/homeImg/home_icon_myaccount@2x.png')" alt="">
            <span style="cursor: default">{{ $t('mall_home.my_account') }}</span>
          </div>
          <div class="accountMask" ref="accountMask">
            <div class="toLogin" v-if="$store.state.token">
              <span style="padding: 5px 0; display: inline-block; color: #A9A499;">{{ $t('mall_home.account_num') }}:
                {{ $store.state.user && $store.state.user.mobile ? $store.state.user.mobile : '' }}</span>
              <el-button size="mini" style="float: right" @click="logout">{{ $t('mall_home.logout') }}</el-button>
            </div>
            <div class="toLogin" v-else>
              <router-link to="/login" @click.native="routerRefresh">
                <span class="first">{{ $t('mall_home.please') }}</span>
                <span>{{ $t('mall_home.login') }}/</span> <!--   登录  -->
                <span>{{ $t('mall_home.register') }}</span> <!--   注册  -->
              </router-link>
            </div>
            <div class="profile">
              <router-link class="self active" tag="div"
                           :to="{ path: '/profile/self-page', query: {redirect: this.$router.currentRoute.fullPath} }">
                <img :src="require('@/assets/homeImg/home_wdzh_icon_gerenxinxi@2x.png')" alt="">
                <span>{{ $t('mall_home.infor') }}</span>  <!--   個人信息    -->
              </router-link>
              <router-link class="order active" tag="div" to="/profile/my-order">
                <img :src="require('@/assets/homeImg/home_wdzh_icon_wddd@2x.png')" alt="">
                <span>{{ $t('mall_home.my_order') }}</span> <!--  我的訂單  -->
              </router-link>
              <router-link class="favorOrder active" tag="div" to="/profile/shopping-cart">
                <img :src="require('@/assets/homeImg/home_icon_shopping@2x.png')" alt="">
                <span>{{ $t('mall_home.my_wishlist') }}</span>  <!--  我的購物車   -->
              </router-link>
            </div>
            <img class="angle" :src="require('@/assets/homeImg/三角形.png')" alt="">
          </div>
        </div>
        <div class="pointer language">
          <el-select :style="{width:language_select_width}" v-model="language" placeholder="Language" @change="changeLanguage">
            <el-option label="Traditional Chinese" value="zh-TW"></el-option>
            <!--            <el-option label="简体中文" value="zh-CN"></el-option>-->
            <el-option label="English" value="en"></el-option>
          </el-select>
        </div>
        <!--        <div class="favor">-->
        <!--          <img :src="require('@/assets/homeImg/home_icon_aixin@2x.png')" alt="">-->
        <!--        </div>-->

        <div class="cart">
          <el-badge :value="shoppingCartList.length" class="item">
            <img :src="require('@/assets/homeImg/home_icon_shopping@2x.png')" alt="">
          </el-badge>
          <img class="cartAngle" :src="require('@/assets/homeImg/三角形.png')" alt="">
          <div class="addCart">
            <div v-for="data in shoppingCartList" :key="data.id" class="cartTop">
              <div class="cartImg">
                <router-link :to="{name:'Product', query:{id:data.product_model_id}}">
                  <img class="pointer" :src="imgUrl + data.product_model.color_photo[0].path" alt="">
                </router-link>

              </div>
              <div class="detail">
                <div class="name">{{ data.product_model.default_name }}</div>
                <div class="cartPrice">${{ data.product_model.areas[0].price | PriceFormat }}</div>
                <div class="color">
                  <span>
                    {{ $t('mall_home.chose') }}<!-- 已選 -->
                    ：{{ data.product_model.color_photo[0].color.name }}；
                    {{ data.product_model.product_size }}</span>
                </div>
              </div>
            </div>
            <div class="cartBot">
              <h3>
                {{ $t('mall_home.total') }}<!-- 總金額 -->
                :${{ getSun()|PriceFormat }}
              </h3>
              <div class="cartCount pointer">
                <router-link to="/profile/shopping-cart" tag="span">
                  {{ $t('mall_home.view_cart') }}<!-- 查看購物袋 -->
                </router-link>
                <span>
                  {{
                    shoppingCartList.length === 0 ? '' :
                      '（' + shoppingCartList.length + $t('mall_home.items') + '）'
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  logo  search-->
    <div class="navHead logoDiv" style="position:relative;">
      <div class="logo">
        <img :src="require('@/assets/homeImg/home_img_logo@2x.png')" alt="">
        <!--<div>JEWELLERY-BOX</div>-->
      </div>
      <div class="search">
        <input v-model="search" ref="search" @keyup.enter="searchHandle" style="font-size: 16px" type="text"
               :placeholder="$t('mall_home.search_series_type')">
        <img @click="searchHandle" class="pointer" :src="require('@/assets/homeImg/home_icon_sousuo@2x.png')" alt="">
      </div>
    </div>

    <!--  title bar  -->
    <div style="align-items: center;position:relative;">
      <div class="displayR" style="width: 100%;justify-content: center;">
        <div class="header">
          <div index="1">
            <router-link to="/jewellery/home"
                         @click.native="routerRefresh">{{ $t('mall_home.jewellery_box') }}<!--搜飾盒--></router-link>
          </div>
          <div index="2" class="bannerWold"
               @mouseover="isShow = true"
               @mouseleave="isShow = false">
            <router-link :to="{name:'Search',query:{type:'reco'}}"
                         @click.native="routerRefresh">{{ $t('mall_home.fine_jewellery') }}  <!-- 珠寶首飾-->
            </router-link>
            <!-- 珠宝首饰悬停页面 -->
            <div class="downMask displayR"
                 :class="{ 'display': !isShow }"
                 id="maskChoose">
              <div class="seriesName">
                <div class="seriesTitle"> {{ $t('mall_home.jewellery_type') }} <!-- 類別 --></div>
                <div class="type" :class="{ 'scroll': series.series && series.series.length > 7 }"
                     @click="isShow = false">
                  <div v-for="row in series.product_types">
                    <router-link :to="{name:'Search',query:{type: row.code}}">{{ row.title }}</router-link>
                  </div>
                  <div>
                    <router-link :to="{name:'Search',query:{type:'series40'}}">{{ $t('mall_home.mens') }}
                      <!-- 男士珠寶 --></router-link>
                  </div>
                  <div>
                    <router-link :to="{name:'Search',query:{type:'series39'}}">{{ $t('mall_home.w_ring') }}
                      <!-- 婚戒&對戒 --></router-link>
                  </div>
                </div>
              </div>
              <div class="seriesName" style="margin-right: 100px">
                <div class="seriesTitle">{{ $t('mall_home.jewellery_collect') }}<!-- 系列 --></div>
                <div class="type" :class="{ 'scroll': series.series && series.series.length > 7 }">
                  <div v-for="row in series.series">
                    <router-link :to="{name:'Search',query:{type:'series' + row.id}}">{{ row.title }}</router-link>
                  </div>
                </div>
              </div>
              <div class="divide"></div>
              <div class="downMaskBanner"><img :src="require('@/assets/homeImg/home_xuanfu_img_banner5@2x.png')" alt="">
              </div>
            </div>
          </div>
          <div index="3">
            <router-link to="/search/gia">{{ $t('mall_home.gia') }}</router-link>
          </div>
          <div index="4" @mouseenter="enterBrandStory" @mouseleave="leaveBrandStory">
            <router-link :to="{name:'BrandStory',query:{type:'about_us'}}">
              {{ $t('mall_home.brand') }}  <!--  品牌世界-->
            </router-link>
            <!--  品牌世界悬停页面 -->
            <div class="downMask displayR"
                 v-show="isShowBrandStory">
              <div style="margin-left: 104px">
                <p class="title"> {{ $t('mall_home.brand_type') }}</p>
                <ul>
                  <router-link key="about_us" class="item_style" tag="li"
                               :to="{name:'BrandStory',query:{type:'about_us'}}">
                    > {{ $t('mall_home.about_us') }}<!-- 我們的品牌 -->
                  </router-link>
                  <router-link key="exchange" class="item_style" tag="li"
                               :to="{name:'BrandStory',query:{type:'exchange'}}">
                    > {{ $t('mall_home.about_exchange') }}<!-- 無限換戴 -->
                  </router-link>
                  <router-link key="vip" class="item_style" tag="li" :to="{name:'BrandStory',query:{type:'vip'}}">
                    > {{ $t('mall_home.about_vip') }}<!-- 尊享體驗 -->
                  </router-link>
                  <router-link key="about_boss" class="item_style" tag="li"
                               :to="{name:'BrandStory',query:{type:'about_boss'}}">
                    > {{ $t('mall_home.about_boss') }}<!-- 強大股東領航 -->
                  </router-link>
                  <router-link key="about_honor" class="item_style" tag="li"
                               :to="{name:'BrandStory',query:{type:'about_honor'}}">
                    > {{ $t('mall_home.about_honor') }} <!-- 企業榮譽 -->
                  </router-link>
                  <router-link key="about_history" class="item_style" tag="li"
                               :to="{name:'BrandStory',query:{type:'about_history'}}">
                    > {{ $t('mall_home.about_history') }} <!-- 發展歷程 -->
                  </router-link>
                  <router-link key="join_us" class="item_style" tag="li"
                               :to="{name:'BrandStory',query:{type:'join_us'}}">
                    > {{ $t('mall_home.about_join_us') }} <!-- 招募合夥人 -->
                  </router-link>
                </ul>
              </div>
              <div class="divider"></div>
              <img v-if="is_language_en" style="width: 553px;height: 239px"
                   :src="require('@/assets/brandStory/brand_story_main_en.png')" alt="">
              <img v-else style="width: 553px;height: 239px"
                   :src="require('@/assets/brandStory/brand_story_main.png')" alt="">
            </div>
          </div>
          <div index="5">
            <router-link to="/app-download">
              {{ $t('mall_home.download') }}<!-- 應用下載 -->
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="line" style="height: 1px;width: 100%;background-color: #ddd;"></div>

    <router-view v-if="routerAlive" v-on:refreshCart="getShoppingCartData" :series="series"></router-view>
    <div class="serviceBox displayR">
      <div style="width: 1200px; display: flex">
        <div class="service">
          <img :src="require('@/assets/homeImg/home_dibu_icon_truck@2x.png')" alt="">
          <div class="seName">
            {{$t('mall_bottom.promise.icon_1')}}<!-- 資深廠商直供 -->
          </div>
        </div>
        <div class="service">
          <img :src="require('@/assets/homeImg/home_dibu_icon_ruku@2x.png')" alt="">
          <div class="seName">
            {{$t('mall_bottom.promise.icon_2')}}<!-- 87項檢測入庫 -->
          </div>
        </div>
        <div class="service">
          <img :src="require('@/assets/homeImg/home_dibu_icon_@2x.png')" alt="">
          <div class="seName">
            {{$t('mall_bottom.promise.icon_3')}} <!-- 100%正品 -->
          </div>
        </div>
        <div class="service">
          <img :src="require('@/assets/homeImg/home_dibu_icon_pei@2x.png')" alt="">
          <div class="seName">
            {{$t('mall_bottom.promise.icon_4')}}<!-- 假一賠三 -->
          </div>
        </div>
        <div class="service">
          <img :src="require('@/assets/homeImg/home_dibu_icon_wxhd@2x.png')" alt="">
          <div class="seName">
            {{$t('mall_bottom.promise.icon_5')}}<!-- 支持無限換戴 -->
          </div>
        </div>
        <div class="service">
          <img :src="require('@/assets/homeImg/home_dibu_icon_shengji@2x.png')" alt="">
          <div class="seName">
            {{$t('mall_bottom.promise.icon_6')}} <!-- 支持升級換戴 -->
          </div>
        </div>
      </div>

    </div>

    <!--尾部-->
    <div style="background-color: #161615;width: 100%">
      <div class="footer displayR container">
        <div>
          <div class="footerTitle">
            {{$t('mall_bottom.about_me.title')}}<!-- 關於我們 -->
          </div>
          <router-link key="about_us" class="link" tag="div"
                       :to="{name:'BrandStory',query:{type:'about_us'}}">
            {{$t('mall_bottom.about_me.about_us')}} <!-- 我們的品牌 -->
          </router-link>
          <router-link key="about_honor" class="link" tag="div"
                       :to="{name:'BrandStory',query:{type:'about_honor'}}">
            {{$t('mall_bottom.about_me.about_honor')}} <!-- 企業榮譽 -->
          </router-link>
          <router-link key="about_history" class="link" tag="div"
                       :to="{name:'BrandStory',query:{type:'about_history'}}">
            {{$t('mall_bottom.about_me.about_history')}} <!-- 發展歷程 -->
          </router-link>
          <router-link key="join_us" class="link" tag="div"
                       :to="{name:'BrandStory',query:{type:'join_us'}}">
            {{$t('mall_bottom.about_me.about_join_us')}} <!-- 招募合夥人 -->
          </router-link>
        </div>
        <div>
          <div class="footerTitle">
           {{$t('mall_bottom.guide.title')}} <!-- 購物指南 -->
          </div>
          <div><a style="color:white"
                  href="https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/mall/diamond_customization.png"
                  target="_blank">
            {{$t('mall_bottom.guide.buy_way')}} <!-- 購買流程 -->
          </a></div>
          <div>
            {{$t('mall_bottom.guide.pay_way')}} <!-- 支付方式 -->
          </div>
          <div>
            {{$t('mall_bottom.guide.store_way')}} <!-- 門市地址 -->
          </div>
          <router-link key="exchange" class="link" tag="li"
                       :to="{name:'BrandStory',query:{type:'exchange'}}">
            {{$t('mall_bottom.guide.about_exchange')}}<!-- 無限換戴 -->
          </router-link>
        </div>
        <!--<div>-->
        <!--<div class="footerTitle">售後服務</div>-->
        <!--<div>退貨流程</div>-->
        <!--<div>辦理售後</div>-->
        <!--<div>15天退換</div>-->
        <!--</div>-->
        <div>
          <div class="footerTitle">
           {{$t('mall_bottom.service.title')}} <!-- 服務中心 -->
          </div>
          <div><a class="link active"
                  href="https://production-api.jewellery-box.com/assets/pages/html/help/%E6%90%9C%E9%A3%BE%E7%9B%92%E9%A9%97%E6%94%B6%E6%A8%99%E6%BA%96%E5%8F%8A%E8%B3%A0%E5%84%9F%E8%A6%8F%E5%89%87.html"
                  target="_blank">
            {{$t('mall_bottom.service.rule_acceptance')}} <!-- 驗收標準及賠償規則 -->
          </a></div>
          <div>
            <a class="link active"
                  href="https://production-api.jewellery-box.com/assets/pages/html/help/%E6%90%9C%E9%A3%BE%E7%9B%92%E6%93%81%E6%9C%89%E8%88%87%E6%8F%9B%E6%88%B4%E6%94%BF%E7%AD%96.html"
                  target="_blank">
              {{$t('mall_bottom.service.rule_exchange')}}<!-- 換戴政策 -->
          </a>
          </div>
          <div><a class="link active"
                  href="https://production-api.jewellery-box.com/assets/pages/html/help/%E6%90%9C%E9%A3%BE%E7%9B%92%E4%BD%BF%E7%94%A8%E8%80%85%E6%A2%9D%E6%AC%BE%E5%8F%8A%E7%B4%B0%E5%89%87.html"
                  target="_blank">
            {{$t('mall_bottom.service.rule_user')}}<!-- 用戶協議 -->
          </a></div>
          <div><a class="link active"
                  href="https://production-api.jewellery-box.com/assets/pages/html/help/privacy_hk.html"
                  target="_blank">
            {{$t('mall_bottom.service.rule_privacy')}}<!-- 隱私政策 -->
          </a></div>
        </div>
        <div>
          <div class="footerTitle">
           {{$t('mall_bottom.download')}} <!-- 下載應用 -->
          </div>
          <div><a class="link active" target="_blank" href="https://apps.apple.com/cn/app/id1438734269">IOS</a></div>
          <div><a class="link active" target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.jmyths.hk">Android</a>
          </div>
        </div>
        <div style="flex: 1.6">
          <div class="footerTitle">
           {{$t('mall_bottom.contact_us')}} <!-- 聯繫我們 -->
          </div>
          <div style="height: 18px;margin-bottom: 32px;">
            <img style="width: 18px;height: 18px;" :src="require('@/assets/homeImg/home_dibu_icon_lianxi@2x.png')"
                 alt="">
            <span style="margin-left: 5px;">(852) 2508-0998</span>

          </div>
          <div style="height: 14px">
            <img style="width: 18px;height: 14px;" :src="require('@/assets/homeImg/home_dibu_icon_youxiang@2x.png')"
                 alt="">
            <span style="margin-left: 5px;">info@jewellery-box.com</span>
          </div>
        </div>
        <div>
          <div class="footerTitle">
           {{$t('mall_bottom.follow_us')}} <!-- 關注我們 -->
          </div>
          <div class="focusUs displayR">
            <img :src="require('@/assets/homeImg/home_dibu_icon_weibo@2x.png')" alt="">
            <span></span>
            <img :src="require('@/assets/homeImg/home_dibu_icon_weixin@2x.png')" alt="">
            <span></span>
            <img :src="require('@/assets/homeImg/home_dibu_icon_facebook@2x.png')" alt="">
            <span style="flex: 0.4"></span>
          </div>
        </div>

        <div style="text-align: center;position: absolute;bottom: 70px;width: 500px;left: 50%; margin-left: -200px">
          <span style="color: white;font-size:14px">
            {{$t('mall_home.company')}}<!-- © 傳承科技有限公司 2020 .版權所有 -->
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from "@/api/baseUrl";
import PriceFormat from '@/assets/js/PriceFormat';

export default {
  name: "Home",
  data() {
    return {
      search: '',
      oldSearch: '',
      series: [],
      area: process.env.AREA,
      itemW: 0,
      isShow: false,
      isShowBrandStory: false,
      paddingNum: '',
      mr: '',
      homeName: '/jewellery/home',
      routerAlive: true,
      shoppingCartList: [],
      imgUrl: baseUrl.imgUrl,
      language: this.$i18n.locale,
      is_language_en: this.$i18n.locale === "en",
      language_select_width: '180px'
    };
  },
  filters: {
    PriceFormat(val) {
      return PriceFormat(val);
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('Logout').then(() => {
        window.location.reload()
      });
    },
    getSeries() {
      this.$axios.get('mall_api/get_product_series', {}).then(res => {
        this.series = res.data.data;
      });
    },
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
    enterBrandStory() {
      this.isShowBrandStory = true
    },
    leaveBrandStory() {
      this.isShowBrandStory = false
    },
    getShoppingCartData() {
      if (this.$store.getters.token) {
        this.$axios.get('api/app_v1/customer/shopping_cart_itemsV2', {}).then(res => {
          this.shoppingCartList = res.data.data;
        })
      }
    },
    getSun() {
      var sun = 0;
      for (var i in this.shoppingCartList) {
        sun += this.shoppingCartList[i].product_model.areas[0].price
      }
      return sun
    },
    searchHandle() {
      if (this.search === this.oldSearch) {
        window.location.reload()
      } else {
        this.$router.push({
          name: 'Search',
          query: {
            type: 'reco',
            search: this.search,
          }
        })
      }
    },
    changeLanguage() {
      if (this.$i18n.locale !== this.language) {
        localStorage.setItem('language', this.language);
        this.language_select_width = this.language === 'en' ? '100px' : '180px';
        this.$i18n.locale = this.language;
        window.location.reload();
      }
    }
  },
  mounted() {
//todo .language .el-select {
//     width: 180px;

  },
  created() {
    this.language_select_width = this.language === 'en' ? '100px' : '180px';
    this.search = this.oldSearch = this.$route.query.search;
    this.getSeries();
    this.getShoppingCartData();
  }
}
</script>

<style lang="less" scoped>

.jewellery {
  min-width: 1200px;
  padding: 0;
  /*margin: 0 auto;*/
}

.navHead {
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
}

.area {
  height: 40px;
  display: flex;
  flex-direction: row;
  /*justify-content: center;*/
  align-items: center;
  float: left;
}

.chooseArea {
  width: 130px;
  font-size: 14px;
  color: #BAA069;
}

/deep/ .chooseArea .el-input__inner {
  padding: 0;
  color: #BAA069;
}

/deep/ .el-select .el-input .el-select__caret {
  color: #BAA069;
}

.positionIcon {
  width: 15px;
  height: 20px;
  margin-right: 5px;
}

.downArrow {
  width: 9px;
  height: 9px;
}

.rightHead {
  font-size: 14px;
  color: #3E3C39;
  float: right;
  /*background-color: #f00;*/
}

.account {
  font-size: 14px;
  color: #3E3C39;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
  position: relative;
  height: 40px;
}

.account:hover .accountMask {
  display: block;
}

/*.account .accountMask{*/
/*display: block;*/
/*}*/
.account > div:first-child > img {
  width: 14px;
  height: 17px;
  margin-right: 5px;
}

.account .angle {
  width: 30px;
  height: 40px;
  position: absolute;
  top: -20px;
  left: 36%;
}

.language {
  float: left;
  font-weight: 400;
}

.language .el-select {
  width: 100px;
}

/deep/ .navHead .el-input__inner {
  border: none;
  background: none;
  padding-right: 5px;
}

/deep/ .language .el-input__inner {
  color: #3E3C39;
}

/deep/ .language .el-select .el-input .el-select__caret {
  color: #3E3C39;
}

.el-select-dropdown__item.selected {
  color: #3E3C39;
}

.languageArrow {
  width: 10px;
  height: 6px;
}

.favor {
  float: left;
  margin-left: 30px;
  margin-right: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.cart {
  float: left;
  display: flex;
  margin-left: 30px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}

.cart:hover .addCart {
  display: block;
}

.cart:hover .cartAngle {
  display: block;
}

.favor > img {
  width: 20px;
  height: 17px;
}

.cart > img {
  width: 15px;
  height: 20px;
}

.addCart {
  position: absolute;
  top: 18px;
  right: -60px;
  z-index: 999;
  width: 340px;
  box-sizing: border-box;
  max-height: 320px;
  background-color: rgba(252, 251, 249, 1);
  box-shadow: 0px 2px 6px 0px rgba(169, 164, 153, 0.38);
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 22px 25px;
  display: none;
  /*display: block;*/
}

.cartAngle {
  width: 30px !important;
  height: 30px !important;
  position: absolute;
  top: 3px;
  right: -16px;
  display: none;
  /*display: block;*/
}

.addCart .cartList {
  width: 100%;
}

.cartImg {
  width: 81px;
  height: 81px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  float: left;
  color: #3E3C39;
  font-size: 16px;

}

.cartTop {
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
  padding: 12px 0;
  display: flex;
}

.cartTop .cartImg {
  margin-right: 21px;
  width: 81px;
  height: 81px;
  display: flex;
}

.cartTop .cartImg img {
  width: 100%;
}

.cartTop .detail {
  overflow: hidden;
  flex: 1;
  font-size: 18px;
  color: #3E3C39;
}

.cartTop .detail .name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cartTop .detail .cartPrice {
  margin-top: 2px;
  padding: 2px 0;
  font-family: STSong;
}

.cartTop .detail .color {
  color: #979694;
  font-size: 14px;
  margin-top: 12px;
}

.cartBot {
  margin-top: 10px;
}

.cartBot h3 {
  text-align: right;
  font-size: 16px;
  color: #3E3C39;
  font-weight: 400;
}

.addCartChoose {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 10px;
}

.addCartChoose > img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.cartCount {
  width: 208px;
  background-color: #4B4946;
  color: #fff;
  padding: 9px 0;
  text-align: center;
  margin: 20px auto;
  font-size: 16px;
  font-weight: 400;
}

.logoDiv {
  position: relative;
  top: -12px;
}

.logo {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #BAA069;
  font-size: 12px;
  font-weight: 600;
}

.logo > img {
  width: 94px;
  height: 77px;
}

.search {
  color: #C5BBB0;
  float: right;
  position: absolute;
  top: 50%;
  right: 10px;

}

.search > input {
  width: 312px;
  height: 36px;
  padding-left: 10px;
  border: 1px solid #C5BBB0;
  border-radius: 4px;
}

.search > img {
  width: 21px;
  height: 22px;
  position: absolute;
  top: 50%;
  margin-top: -10px;
  right: 10px;
}

input::-webkit-input-placeholder { /* WebKit browsers */
  color: #C5BBB0;
}

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #C5BBB0;
}

input::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #C5BBB0;
}

input:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #C5BBB0;
}

.el-menu {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.el-menu--horizontal > .el-menu-item {
  position: relative;
  color: #242320 !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid transparent !important;
  color: #BAA069 !important;
}

.header .el-menu--horizontal > .el-menu-item.is-active::after {
  content: '';
  display: block;
  width: 20px;
  height: 2px;
  background-color: #BAA069;
  position: absolute;
  left: 50%;
  margin-left: -10px;

}

.downMask {
  width: 1200px;
  height: 330px;
  background-color: #fff;
  padding: 45px;
  box-sizing: border-box;
  position: absolute;
  top: 66px;
  left: 50%;
  margin-left: -600px;
  z-index: 9999;
  align-items: center;
  color: #5B5957;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  -webkit-box-shadow: 1px 1px 10px 1px rgba(30, 19, 3, 0.13);
  -moz-box-shadow: 1px 1px 10px 1px rgba(30, 19, 3, 0.13);
  box-shadow: 1px 1px 10px 1px rgba(30, 19, 3, 0.13);
  /*display: block;*/

}

.el-menu-item:hover {
  color: #BAA069 !important;
}


.downMaskBanner {
  width: 553px;
  height: 239px;
  /*padding: 45px 0;*/
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  float: right;
}

.downMaskBanner > img {
  width: 100%;
  height: 100%;
}

.seriesName {
  height: 100%;
  width: 150px;
  margin-top: 45px;
}

.seriesTitle {
  color: #3E3C39;
  margin-bottom: 20px;
  font-size: 16px;
}

.divide {
  width: 1px;
  height: 166px;
  background-color: #ddd;
  margin-right: 88px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-active {
  opacity: 0
}


/*服務*/
.serviceBox {
  justify-content: center;
  /*border-top: 1px solid rgba(24, 14, 3, 0.06);*/
  padding-top: 30px;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, .1);
}

.service {
  flex: 1;
  margin-right: 100px;
  text-align: center
}

.service:last-child {
  margin-right: 0;
}

.service > img {
  width: 60px;
  height: 60px;
}

.seName {
  font-size: 14px;
  color: #454340;
}

/*尾部*/
.footer {
  width: 1200px;
  height: 353px;
  font-size: 14px;
  color: #E3E3E3;
  justify-content: center;
  padding: 45px 10px;
  /*padding: 45px 210px;*/
  box-sizing: border-box;
  margin-top: 30px;
  display: flex;
}

.footer > div {
  flex: 1;
}

.footer .footerTitle {
  color: #6F6F6E;
  font-size: 16px;
  margin-bottom: 20px;
}

.footer .link {
  color: white;
  cursor: pointer;
}

.footer .link:hover {
  text-decoration: underline;
}

.focusUs {
  display: flex;
}

.focusUs > span {
  flex: 1;
}

.focusUs > img {
  width: 35px;
  height: 35px;
}

.focusUs > img:last-child {
  margin-right: 0;
}

/*登錄*/
.accountMask {
  position: absolute;
  top: 28px;
  left: -80%;
  width: 320px;
  background-color: #f7f5f1;
  color: #3E3C39;
  padding: 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: none;
  z-index: 999;
  box-shadow: 0px 2px 6px 0px rgba(169, 164, 153, 0.38);

}

.accountMask div {
  cursor: pointer;
}

.toLogin {
  overflow: hidden;
  padding: 5px 10px 10px 15px;
}

.profile {
  background-color: #fff;
  width: 100%;
  padding: 5px 20px 20px 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.profile > div {
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

}

.self > img {
  width: 17px;
  height: 18px;
  margin-right: 10px;
}

.order > img {
  width: 15px;
  height: 18px;
  margin-right: 10px;
}

.favorOrder > img {
  width: 15px;
  height: 20px;
  margin-right: 10px;
}

.header {
  width: 70%;
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  font-size: 14px;
}

.header > div {
  width: 25%;
  text-align: center;
  padding: 7px 0;
}

.header > div > a {
  padding-bottom: 10px;
}

.active:hover {
  color: #BAA069 !important;
}

.active {
  position: relative;
}

.bannerWold:hover {
  color: #BAA069;
}

.type {
  max-height: 160px;
  cursor: pointer;
}

.scroll {
  overflow-y: scroll;
}

.type::-webkit-scrollbar {
  background-color: #FFF;
}

/*定义滑块 内阴影+圆角*/
.type::-webkit-scrollbar-thumb {
  border: 2px solid #FFF;
  box-shadow: inset 0 0 0 rgba(148, 148, 148, .3);
  background-color: rgba(68, 68, 68, 0.3);
}

.type > div:hover {
  font-weight: 500;
}

.el-badge {
  width: 15px;
  height: 20px;
}

.el-badge > img {
  width: 100%;
}

/deep/ .el-badge > sup {
  width: 18px;
}

.title {
  width: 32px;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(62, 60, 57, 1);
  line-height: 22px;
  margin-bottom: 20px;
}

.item_style {
  width: 250px;
  height: 25px;
  font-size: 14px;
  color: rgba(91, 89, 87, 1);
  line-height: 20px;
  text-align: left;
}

.item_style:hover {
  color: #3E3C39;
  cursor: pointer;
}

.divider {
  width: 1px;
  height: 166px;
  background-color: #DDDDDD;
  margin: 0 88px 0 60px;
}

.display {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Home.vue